var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-justify"},[(_vm.status)?_c('form-v2-oeap-location-acc-bodies-index',{attrs:{"title":_vm.$store.getters.getTag('4'),"subtitle":_vm.$store.getters.getTag('4.S'),"footer":_vm.$store.getters.getTag('4.F'),"activity":_vm.activity,"disabled":_vm.disabled}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }